import Color, { AirportAppColor } from '@/utils/color';

export const Theme = {
  default: {
    color: {
      primary: Color.DarkGreen,
      secondary: Color.Cyan,
      accent: Color.Cyan,
      highlight: Color.Cyan,
      text: Color.DarkGreen,
    },
  },
  airport: {
    color: {
      primary: AirportAppColor.Wine,
      secondary: AirportAppColor.Red,
      accent: AirportAppColor.Turquoise,
      highlight: Color.Cyan,
      text: Color.Black,
    },
  },
  vytal: {
    // Should be the same as in scss/custom.scss where we override the default bootstrap theme
    color: {
      primary: '#1cc282',
      secondary: '#939393',
      success: '#1cc282',
      info: '#0dcaf0',
      warning: '#f6ad55',
      danger: '#f04e26',
      dark: '#1c1a20',
      light: '#f5f5f5',
    },
    breakpoints: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
    },
  },
};
